export default {
      id: "icon-plus-1-usage",
      viewBox: "0 0 17 18",
      url: "../icon/" + "icons.svg#icon-plus-1-usage",
      toString: function () {
        return this.url;
      }
    }